import { VERSION } from "@/apis";
import { downloadFileUrl } from "@/apis/file";

const getFileBuffer = async (fileId: string, wmsApi?: string) => {
  let downUrl = downloadFileUrl(fileId, wmsApi);
  if (!!!downUrl) return Promise.reject(10086)
  try {
    let fileResponse = await fetch(downUrl, {
      headers: {
        "g_wms_version": VERSION,
        "g_wms_app_type": "WEB"
      }
    })
    if (!fileResponse.ok) return Promise.reject("获取文件响应失败")
    else {
      const buffer = await fileResponse.arrayBuffer();
      return Promise.resolve(buffer);
    }
  } catch (error) {
    return Promise.reject(error)
  }
};
export default getFileBuffer;